// Calculo de horas trabajadas por leccion.
//
// Antes el total era `lessons.length * 1.5`, lo que ignoraba la duracion real de cada clase
// (una de 60 min y otra de 90 min sumaban igual). La fuente oficial de la duracion son
// `class.startHour` / `class.endHour`, strings en formato 'hh:mm A' (ej. '07:00 PM').
//
// ponytail: la duracion es una diferencia de reloj de pared dentro del mismo dia, asi que
// moment/timezone no aporta nada aqui. Extension .mjs a proposito: webpack lo resuelve igual
// que .js y node lo ejecuta nativo.

import { to24h } from './hours.js'

// '07:30 PM' -> 1170 (minutos desde medianoche). null si no se puede parsear.
//
// La hora la interpreta to24h, el MISMO parser que usa la creacion del evento de Calendar.
// Antes habia aqui un regex propio que solo entendia 'hh:mm AM/PM', y las clases reales no
// estan escritas asi: 'Intermediate - Miercoles con Luisa' tiene '6pm' a '7.30pm' y
// 'Beginners Two - Lunes con Ursula' tiene '6.00 pm' a '7.30 pm'. Para el reporte esas
// clases duraban null, o sea cero horas, y sus profesoras no cobraban el mes entero.
//
// Dos parsers para el mismo dato es la forma de que uno se quede atras sin que nadie lo note.
export function parseHourToMinutes (value) {
  const hora = to24h(value)
  if (!hora) return null

  const [horas, minutos] = hora.split(':')
  return Number(horas) * 60 + Number(minutos)
}

// Duracion de una leccion en horas decimales. null si falta u es invalido el horario.
export function lessonDurationHours (lesson) {
  const classItem = lesson && lesson.class
  if (!classItem) return null

  const start = parseHourToMinutes(classItem.startHour)
  const end = parseHourToMinutes(classItem.endHour)
  if (start === null || end === null) return null

  // Una clase que cruza medianoche (ej. 11:30 PM a 12:30 AM) da negativo: sumar el dia.
  const durationMinutes = end > start ? end - start : end - start + 24 * 60
  if (durationMinutes <= 0) return null

  return durationMinutes / 60
}

// Suma las horas del mes. Las lecciones CANCELLED no cuentan (regla actual del sistema).
// Devuelve tambien cuantas quedaron sin horario para poder avisarlo en la UI en vez de
// perderlas en silencio.
export function sumLessonHours (lessons) {
  const dictated = (lessons || []).filter(item => item && item.state !== 'CANCELLED')

  let hours = 0
  let unknown = 0
  dictated.forEach(lesson => {
    const duration = lessonDurationHours(lesson)
    if (duration === null) {
      unknown += 1
    } else {
      hours += duration
    }
  })

  // Evita 5.999999999 por aritmetica de punto flotante.
  return { hours: Math.round(hours * 100) / 100, unknown }
}

// Que lecciones entran en el reporte de un profesor.
//
// Regla del cliente (Giancarlo, 11-sep-2026): si Andres no puede dar su clase y la cubre
// Giancarlo, esas 1.5 h son de Giancarlo. Al abrir [Ver reporte], Giancarlo ve sus clases
// normales MAS la que cubrio; Andres no ve esa, porque no la dio.
//
// Hasta ahora la leccion se archivaba siempre a nombre del titular (class.teacher.id) y el
// sustituto no cobraba nada por cubrir.
//
// Recibe los dos conjuntos ya leidos de Firestore porque esto es un OR sobre dos campos
// distintos y hacen falta dos consultas. Las lecciones viejas no tienen 'coveredBy': al ser
// undefined siguen contando para su titular, que es lo correcto.
export function lessonsForTeacher (propias, cubiertas, teacherId) {
  // Map y no un array: una leccion podria aparecer en las dos listas y no debe contarse dos
  // veces (duplicaria las horas).
  const porId = new Map()

  ;(propias || []).forEach(lesson => {
    if (!lesson) return
    // La propia solo cuenta si nadie la cubrio.
    if (!lesson.coveredBy || lesson.coveredBy.id === teacherId) {
      porId.set(lesson.id, lesson)
    }
  })

  ;(cubiertas || []).forEach(lesson => {
    if (lesson) porId.set(lesson.id, lesson)
  })

  return [...porId.values()]
}
